import { environment } from "src/environments/environment.prod";

export const EPIGRAFO_API = environment.api;

/** base de dados teste */
export const account_token = environment.account_token;

